const data = {
  countrys: [
    { text: 'Hong Kong', value: '852', market: 'MY' },
    { text: 'Singapore', value: '65', market: 'SG' },
    { text: 'USA', value: '1', market: 'MY' },
    { text: 'China', value: '86', market: 'MY' },
    { text: 'Japan', value: '81', market: 'MY' },
    { text: 'Macao', value: '853', market: 'MY' },
    { text: 'Taiwan', value: '886', market: 'MY' },
    { text: 'Malaysia', value: '60', market: 'MY' },
    { text: 'United Kingdom', value: '44', market: 'MY' },
    { text: 'Thailand', value: '66', market: 'MY' }
  ]
}

export default {
  data
}
